export interface Product {
  id: number;
  name: string;
  price: number;
  image: string;
  category: 'apparel' | 'footwear' | 'accessories';
  subcategory?: string;
  isNew?: boolean;
  isFeatured?: boolean;
  sizes?: string[];
  colors?: string[];
}

export const products: Product[] = [
  // Apparel - Jackets
  {
    id: 1,
    name: 'Varsity Legacy Jacket',
    price: 189,
    image: 'https://public.readdy.ai/ai/img_res/ee0f35e23706d180ba3e7ca9f2fd908b.jpg',
    category: 'apparel',
    subcategory: 'jackets',
    isNew: true,
    isFeatured: true,
    sizes: ['S', 'M', 'L', 'XL', '2XL'],
    colors: ['black', 'white'],
  },
  {
    id: 2,
    name: 'Northside Bomber',
    price: 165,
    image: 'https://readdy.ai/api/search-image?query=black%20premium%20bomber%20jacket%20with%20minimal%20branding%20hanging%20on%20clean%20background%20with%20studio%20lighting%20in%20editorial%20streetwear%20product%20photography%20style&width=600&height=800&seq=bomber-jacket-2&orientation=portrait',
    category: 'apparel',
    subcategory: 'jackets',
    isNew: true,
    sizes: ['S', 'M', 'L', 'XL'],
    colors: ['black', 'gray'],
  },
  {
    id: 3,
    name: 'Statement Puffer',
    price: 210,
    image: 'https://readdy.ai/api/search-image?query=oversized%20black%20puffer%20jacket%20with%20bold%20design%20hanging%20on%20minimalist%20rack%20with%20dramatic%20lighting%20clean%20dark%20background%20in%20premium%20streetwear%20photography%20style&width=600&height=800&seq=puffer-jacket-3&orientation=portrait',
    category: 'apparel',
    subcategory: 'outerwear',
    isFeatured: true,
    sizes: ['M', 'L', 'XL', '2XL'],
    colors: ['black'],
  },
  // Apparel - Hoodies
  {
    id: 4,
    name: 'Culture Hoodie',
    price: 85,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20hoodie%20with%20minimal%20white%20logo%20hanging%20on%20clean%20background%20with%20studio%20lighting%20in%20editorial%20streetwear%20product%20photography%20style&width=600&height=800&seq=hoodie-4&orientation=portrait',
    category: 'apparel',
    subcategory: 'hoodies',
    isNew: true,
    sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL'],
    colors: ['black', 'gray', 'white'],
  },
  {
    id: 5,
    name: 'Unity Pullover',
    price: 95,
    image: 'https://readdy.ai/api/search-image?query=oversized%20black%20pullover%20hoodie%20with%20bold%20graphic%20hanging%20on%20minimalist%20rack%20with%20dramatic%20studio%20lighting%20clean%20dark%20background%20in%20streetwear%20photography%20style&width=600&height=800&seq=pullover-5&orientation=portrait',
    category: 'apparel',
    subcategory: 'hoodies',
    sizes: ['M', 'L', 'XL', '2XL'],
    colors: ['black', 'gray'],
  },
  // Apparel - Tees
  {
    id: 6,
    name: 'Northside Tee',
    price: 45,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20t-shirt%20with%20white%20graphic%20print%20hanging%20on%20clean%20background%20with%20studio%20lighting%20in%20editorial%20streetwear%20product%20photography%20style&width=600&height=800&seq=tee-6&orientation=portrait',
    category: 'apparel',
    subcategory: 'tees',
    isNew: true,
    sizes: ['S', 'M', 'L', 'XL', '2XL', '3XL'],
    colors: ['black', 'white', 'gray'],
  },
  {
    id: 7,
    name: 'Hustle Graphic Tee',
    price: 50,
    image: 'https://readdy.ai/api/search-image?query=black%20oversized%20t-shirt%20with%20bold%20white%20typography%20hanging%20on%20minimalist%20rack%20with%20dramatic%20lighting%20clean%20dark%20background%20in%20streetwear%20photography%20style&width=600&height=800&seq=graphic-tee-7&orientation=portrait',
    category: 'apparel',
    subcategory: 'tees',
    sizes: ['S', 'M', 'L', 'XL', '2XL'],
    colors: ['black', 'white'],
  },
  // Apparel - Pants
  {
    id: 8,
    name: 'Cargo Joggers',
    price: 95,
    image: 'https://readdy.ai/api/search-image?query=black%20premium%20cargo%20joggers%20with%20multiple%20pockets%20hanging%20on%20clean%20background%20with%20studio%20lighting%20in%20editorial%20streetwear%20product%20photography%20style&width=600&height=800&seq=joggers-8&orientation=portrait',
    category: 'apparel',
    subcategory: 'pants',
    isNew: true,
    sizes: ['S', 'M', 'L', 'XL', '2XL'],
    colors: ['black', 'gray'],
  },
  {
    id: 9,
    name: 'Street Sweatpants',
    price: 75,
    image: 'https://readdy.ai/api/search-image?query=black%20tapered%20sweatpants%20with%20minimal%20branding%20hanging%20on%20minimalist%20rack%20with%20dramatic%20studio%20lighting%20clean%20dark%20background%20in%20streetwear%20photography%20style&width=600&height=800&seq=sweatpants-9&orientation=portrait',
    category: 'apparel',
    subcategory: 'pants',
    sizes: ['S', 'M', 'L', 'XL', '2XL'],
    colors: ['black', 'gray', 'navy'],
  },
  // Footwear - Sneakers
  {
    id: 10,
    name: 'Urban High-Tops',
    price: 145,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20high-top%20sneakers%20with%20white%20sole%20displayed%20on%20clean%20minimalist%20pedestal%20with%20dramatic%20studio%20lighting%20dark%20background%20in%20editorial%20product%20photography%20style&width=600&height=800&seq=high-tops-10&orientation=portrait',
    category: 'footwear',
    subcategory: 'high-tops',
    isNew: true,
    isFeatured: true,
    sizes: ['8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12'],
    colors: ['black', 'white'],
  },
  {
    id: 11,
    name: 'Street Runner',
    price: 125,
    image: 'https://readdy.ai/api/search-image?query=black%20and%20white%20low-top%20sneakers%20with%20modern%20design%20displayed%20on%20clean%20surface%20with%20studio%20lighting%20dark%20background%20in%20editorial%20footwear%20photography%20style&width=600&height=800&seq=runner-11&orientation=portrait',
    category: 'footwear',
    subcategory: 'low-tops',
    isNew: true,
    sizes: ['7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '12'],
    colors: ['black', 'white', 'gray'],
  },
  {
    id: 12,
    name: 'Classic Low',
    price: 110,
    image: 'https://readdy.ai/api/search-image?query=minimalist%20black%20canvas%20sneakers%20with%20white%20sole%20displayed%20on%20clean%20pedestal%20with%20dramatic%20studio%20lighting%20dark%20background%20in%20editorial%20product%20photography%20style&width=600&height=800&seq=classic-low-12&orientation=portrait',
    category: 'footwear',
    subcategory: 'low-tops',
    sizes: ['8', '8.5', '9', '9.5', '10', '10.5', '11', '12'],
    colors: ['black', 'white'],
  },
  // Footwear - Boots
  {
    id: 13,
    name: 'Combat Boots',
    price: 185,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20leather%20combat%20boots%20with%20laces%20displayed%20on%20clean%20minimalist%20surface%20with%20dramatic%20studio%20lighting%20dark%20background%20in%20editorial%20footwear%20photography%20style&width=600&height=800&seq=combat-boots-13&orientation=portrait',
    category: 'footwear',
    subcategory: 'boots',
    isFeatured: true,
    sizes: ['8', '9', '10', '11', '12'],
    colors: ['black'],
  },
  // Footwear - Slides
  {
    id: 14,
    name: 'Logo Slides',
    price: 55,
    image: 'https://readdy.ai/api/search-image?query=black%20premium%20slides%20with%20white%20logo%20branding%20displayed%20on%20clean%20surface%20with%20studio%20lighting%20dark%20background%20in%20editorial%20product%20photography%20style&width=600&height=800&seq=slides-14&orientation=portrait',
    category: 'footwear',
    subcategory: 'slides',
    isNew: true,
    sizes: ['7', '8', '9', '10', '11', '12'],
    colors: ['black', 'white'],
  },
  // Accessories - Hats
  {
    id: 15,
    name: 'Northside Cap',
    price: 35,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20baseball%20cap%20with%20white%20embroidered%20logo%20displayed%20on%20clean%20minimalist%20surface%20with%20dramatic%20studio%20lighting%20dark%20background%20in%20editorial%20product%20photography%20style&width=600&height=800&seq=cap-15&orientation=portrait',
    category: 'accessories',
    subcategory: 'hats',
    isNew: true,
    sizes: ['One Size'],
    colors: ['black', 'white', 'gray'],
  },
  {
    id: 16,
    name: 'Culture Beanie',
    price: 30,
    image: 'https://readdy.ai/api/search-image?query=black%20knit%20beanie%20with%20minimal%20white%20logo%20patch%20displayed%20on%20clean%20surface%20with%20studio%20lighting%20dark%20background%20in%20editorial%20product%20photography%20style&width=600&height=800&seq=beanie-16&orientation=portrait',
    category: 'accessories',
    subcategory: 'hats',
    sizes: ['One Size'],
    colors: ['black', 'gray'],
  },
  // Accessories - Bags
  {
    id: 17,
    name: 'Street Backpack',
    price: 95,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20backpack%20with%20minimal%20design%20and%20white%20details%20displayed%20on%20clean%20minimalist%20surface%20with%20dramatic%20studio%20lighting%20dark%20background%20in%20editorial%20product%20photography%20style&width=600&height=800&seq=backpack-17&orientation=portrait',
    category: 'accessories',
    subcategory: 'bags',
    isNew: true,
    isFeatured: true,
    sizes: ['One Size'],
    colors: ['black'],
  },
  {
    id: 18,
    name: 'Crossbody Bag',
    price: 65,
    image: 'https://readdy.ai/api/search-image?query=black%20premium%20crossbody%20bag%20with%20adjustable%20strap%20displayed%20on%20clean%20surface%20with%20studio%20lighting%20dark%20background%20in%20editorial%20product%20photography%20style&width=600&height=800&seq=crossbody-18&orientation=portrait',
    category: 'accessories',
    subcategory: 'bags',
    sizes: ['One Size'],
    colors: ['black', 'gray'],
  },
  // Accessories - Jewelry
  {
    id: 19,
    name: 'Chain Necklace',
    price: 75,
    image: 'https://readdy.ai/api/search-image?query=silver%20chain%20necklace%20with%20pendant%20displayed%20on%20clean%20black%20surface%20with%20dramatic%20studio%20lighting%20dark%20background%20in%20editorial%20jewelry%20photography%20style&width=600&height=800&seq=necklace-19&orientation=portrait',
    category: 'accessories',
    subcategory: 'jewelry',
    isFeatured: true,
    sizes: ['One Size'],
    colors: ['white'],
  },
  {
    id: 20,
    name: 'Statement Ring',
    price: 45,
    image: 'https://readdy.ai/api/search-image?query=silver%20statement%20ring%20with%20bold%20design%20displayed%20on%20clean%20black%20surface%20with%20dramatic%20studio%20lighting%20dark%20background%20in%20editorial%20jewelry%20photography%20style&width=600&height=800&seq=ring-20&orientation=portrait',
    category: 'accessories',
    subcategory: 'jewelry',
    sizes: ['One Size'],
    colors: ['white'],
  },
  // Accessories - Belts
  {
    id: 21,
    name: 'Logo Belt',
    price: 55,
    image: 'https://readdy.ai/api/search-image?query=black%20premium%20belt%20with%20silver%20buckle%20and%20logo%20displayed%20on%20clean%20minimalist%20surface%20with%20dramatic%20studio%20lighting%20dark%20background%20in%20editorial%20product%20photography%20style&width=600&height=800&seq=belt-21&orientation=portrait',
    category: 'accessories',
    subcategory: 'belts',
    sizes: ['S/M', 'L/XL'],
    colors: ['black', 'white'],
  },
  // Accessories - Socks
  {
    id: 22,
    name: 'Crew Socks 3-Pack',
    price: 25,
    image: 'https://readdy.ai/api/search-image?query=black%20premium%20crew%20socks%20with%20white%20logo%20displayed%20on%20clean%20surface%20with%20studio%20lighting%20dark%20background%20in%20editorial%20product%20photography%20style&width=600&height=800&seq=socks-22&orientation=portrait',
    category: 'accessories',
    subcategory: 'socks',
    isNew: true,
    sizes: ['One Size'],
    colors: ['black', 'white', 'gray'],
  },
];